export enum SUPPORT_ACCORDION_SECTIONS {
  REPORT_ISSUE = "report-issue",
  DELETE_REQUEST = "delete-request",
}

